<template>
  <el-form-item class="border-input" :label="label">
    <el-row type="flex" justify="middle" align="middle" v-if="simpleInput" :gutter="20">
      <el-col :span="6">
        <el-input-number v-model="inputValue" size="mini" controls-position="right" :min="0" @change="handleInputChange"> </el-input-number>
      </el-col>
      <el-col :span="12">
        <el-link class="advanced" type="primary" @click="simpleInput = false">zaawansowane</el-link>
      </el-col>
    </el-row>
    <el-row type="flex" v-else>
      <div class="size">
        <p>Góra</p>
        <el-input-number size="mini" v-model="value.top" controls-position="right" :min="0"></el-input-number>
      </div>
      <div class="size">
        <p>Prawo</p>
        <el-input-number size="mini" v-model="value.right" controls-position="right" :min="0"></el-input-number>
      </div>
      <div class="size">
        <p>Dół</p>
        <el-input-number size="mini" v-model="value.bottom" controls-position="right" :min="0"></el-input-number>
      </div>
      <div class="size">
        <p>Lewo</p>
        <el-input-number size="mini" v-model="value.left" controls-position="right" :min="0"></el-input-number>
      </div>
    </el-row>
  </el-form-item>
</template>

<script>
export default {
  name: 'BorderInput',
  props: {
    label: {
      type: String,
      default: 'Obramowanie',
    },
    value: {
      require: true,
    },
  },
  data() {
    return {
      inputValue: 0,
      simpleInput: true,
    };
  },
  watch: {
    value(border) {
      this.inputValue = 0;
      this.simpleInput = this.allValuesTheSame(border);
    },
  },
  methods: {
    handleInputChange(value) {
      this.value.top = value;
      this.value.bottom = value;
      this.value.left = value;
      this.value.right = value;
    },
    allValuesTheSame(border) {
      return Object.values(border).every((val, i, arr) => val === arr[0]);
    },
  },
};
</script>

<style lang="less">
.advanced.el-link {
  margin: 0;
  line-height: 1;
  font-weight: 400;
}

.size {
  p {
    font-size: 12px;
    margin: 0;
    line-height: 1;
  }
  + .size {
    margin-left: 20px;
  }
}
</style>
